<div class="flex h-screen flex-row items-center justify-center">
  <app-portal-panel class="h-[40rem] max-h-full w-3xl max-w-full">
    <div class="m-6 flex h-full flex-col gap-4">
      <!-- Top bar -->
      <div class="flex flex-row justify-between">
        <div class="barlow-semi-condensed-bold text-5xl text-white">Klas: {{ className() }}</div>
        <button
          (click)="clickedSwitchClass.emit()"
          class="barlow-medium h-7 w-[148px] rounded-md border border-white text-center align-middle text-base text-white"
        >
          Klas wisselen
        </button>
      </div>
      <!-- text -->
      <div class="barlow-regular text-2xl text-white">Klik op een profiel om het te spelen.</div>
      <!-- profiles -->
      <div class="flex flex-row flex-wrap justify-between gap-6 overflow-x-hidden overflow-y-auto">
        @for (profile of profiles(); track $index) {
          <app-portal-button
            class="h-[105px] max-w-[calc(50%-0.75rem)] min-w-[220px] flex-1 basis-[calc(50%-0.75rem)]"
            color="blue"
            (clicked)="clickedProfile.emit(profile)"
          >
            <div class="flex flex-row items-center justify-start gap-4 p-4">
              <app-portal-profile class="size-16"></app-portal-profile>
              <span class="barlow-medium text-xl"> {{ profile.nickname }}</span>
            </div>
          </app-portal-button>
        }
      </div>
    </div>
  </app-portal-panel>
</div>
